// Returns true if element is in viewport
const isElementVisible = ele => {
  if (!ele) {
    return false;
  }
  const {
    top,
    bottom
  } = ele.getBoundingClientRect();
  const vHeight = window.innerHeight || document.documentElement.clientHeight;
  return (top >= 0 || bottom > 0) && top < vHeight;
};
export { isElementVisible };